import React from 'react';
import { artifactStatusMap, pubArtifactsStatusWarnMsg, userSelectableArtifactStatus } from '../../Constants/Files';
import ModelStatusDropDown from '../CreateAsset/ReviewAndSubmit/ModelStatusDropdown';
import { changeArtifactStatus } from '../../redux/actions/manageAssetActions';
import { useDispatch } from 'react-redux';
import PublishedArtifactsWarningDrawer from './PublishedArtifactsWarningDialog';
import { useState } from 'react';
import { hasSimilarTypePublishedArtifacts, isTerminalStatus } from '../../Utils/FileUtils';

function ArtifactStatusDropdownContainer({ asset, sourceFile, artifact }) {
	const { status } = artifact;
	const dispatch = useDispatch();
	const [open, setOpen] = useState(false);
	// State contains newly changed status for an artifact.
	const [newStatus, setNewStatus] = useState('');
	const handleDrawerBtnClick = () => {
		setOpen(false);
		dispatch(changeArtifactStatus({ asset, sourceFile, artifact, status: newStatus }));
	};
	const drawerProps = {
		open,
		setOpen,
		primaryBtnClick: handleDrawerBtnClick,
		msg: pubArtifactsStatusWarnMsg,
	};

	// artifact on change status
	const artifactStatusOnChange = (status) => {
		// User can only select status part of userSelectableArtifactStatus set.
		if (userSelectableArtifactStatus.has(status)) {
			setNewStatus(status);
			// Throw a warning dialog, before changing artifact status. if the source file is primary and already has a similar type (GLB or USDZ) artifact that has been published.
			if (
				sourceFile.isPrimary &&
				hasSimilarTypePublishedArtifacts(sourceFile, artifact.type) &&
				isTerminalStatus(status)
			) {
				setOpen(true);
			} else {
				dispatch(changeArtifactStatus({ asset, sourceFile, artifact, status }));
			}
		}
	};
	return (
		<>
			<ModelStatusDropDown
				asset={asset}
				file={artifact}
				handleManageAssetFileStatusOnChange={artifactStatusOnChange}
				toolTipTitle={
					'This generated file is ' + artifactStatusMap[status].label + ' Click to change its status'
				}
			></ModelStatusDropDown>
			{open ? <PublishedArtifactsWarningDrawer {...drawerProps} /> : null}
		</>
	);
}

export default ArtifactStatusDropdownContainer;
